export default __webpack_public_path__ + "static/B0289-e7093e56f91f1423c3dc3f16267362b8.png";